export const PATHS = {
  ROOT: '/',
  UNAVAILABLE_SERVICE: 'unavailable-service',
  WIDGETS: 'widgets',
};
